import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import LoadChatSessions from '../loaders/LoadChatSessions';
import LoadConnections from '../loaders/LoadConnections';
import GlobalChatRoom from '../screens/chat/GlobalChatRoom';
import GlobalChatSessions from '../screens/chat/GlobalChatSessions';

export const innerGlobalChatRoutes = props => (
    <LoadConnections>
        <LoadChatSessions>
            <Switch>
                <Route path={`${props.match.path}/new`} component={GlobalChatRoom} />
                <Route path={`${props.match.path}/:chatSessionId`} exact component={GlobalChatRoom} />
                <Redirect to="." />
            </Switch>
        </LoadChatSessions>
    </LoadConnections>
);

export default props => (
    <LoadConnections>
        <LoadChatSessions>
            <Switch>
                <Route path={`${props.match.path}/new`} component={GlobalChatRoom} />
                <Route path={`${props.match.path}/:chatSessionId`} exact component={GlobalChatRoom} />
                <Route path={`${props.match.path}`} exact component={GlobalChatSessions} />
                <Redirect to={`${props.match.path}`} />
            </Switch>
        </LoadChatSessions>
    </LoadConnections>
);
